import React, { Component } from 'react';
import _ from 'lodash';
import TagCloud from 'react-tag-cloud';
import randomColor from 'randomcolor';
import { updateTagId, projectListingGrid } from "../../actions/DashboardAction";
import { connect } from 'react-redux';
import WordCloud from 'react-d3-cloud';

const skillsToDraw = [
    { text: 'javascript', size: 34, rot:false },
    { text: 'D3.js', size: 20, rot:true },
    { text: 'coffeescript', size: 34, rot:false },
    { text: 'shaving sheep', size: 24, rot:false },
    { text: 'AngularJS', size: 30, rot:false },
    { text: 'Ruby', size: 20, rot:true },
    { text: 'ECMAScript', size: 15 , rot:false },
    { text: 'Actionscript', size: 20, rot:false },
    { text: 'Linux', size: 20, rot:false },
    { text: 'C++', size: 25, rot:false },
    { text: 'C#', size: 35, rot:true },
    { text: 'JAVA', size: 28, rot:false },
  // just copy twice for extra data, else the cloud is a little boring
    { text: 'javascript', size: 25 , rot:false },
    { text: 'D3.js', size: 12, rot:true },
    { text: 'coffeescript', size: 20, rot:false },
    { text: 'shaving sheep', size: 16 , rot:false },
    { text: 'AngularJS', size: 35, rot:false },
    { text: 'Ruby', size: 16 , rot:false },
    { text: 'ECMAScript', size: 14 , rot:true },
    { text: 'Actionscript', size: 18, rot:true },
    { text: 'Linux', size: 20, rot:false },
    { text: 'C++', size: 22 , rot:false },
    { text: 'C#', size: 28, rot:false },
    { text: 'JAVA', size: 18, rot:false },
    { text: 'javascript', size: 16 , rot:true },
    { text: 'D3.js', size: 30, rot:false },
    { text: 'coffeescript', size: 12 , rot:false },
    { text: 'shaving sheep', size: 16, rot:false },
    { text: 'AngularJS', size: 22, rot:false },
    { text: 'Ruby', size: 28, rot:true },
    { text: 'ECMAScript', size: 12, rot:false },
    { text: 'Actionscript', size: 16, rot:false },
    { text: 'Linux', size: 16, rot:false },
    { text: 'C++', size: 14, rot:true },
    { text: 'C#', size: 16, rot:false },
    { text: 'JAVA', size: 24, rot:true }
];

const fontSizeMapper = word => word.size;
const rotate = word => {
    if(word.rot){
        return 90;
    }else {
        return 0;
    }
}
const onWordClick = word => console.log(word)

class WordCloudMasonry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tagStyle : {},
            tagPadding: 10
        };
    }

    /**
     * On component mount
     */
    componentWillMount() {
        const set1 = [30, 36, 44, 56, 72];
        const set2 = [24, 30, 36, 44, 56];
        const set3 = [20, 24, 30, 36, 44];
        const set4 = [18, 20, 24, 30, 36];
        const set5 = [15, 18, 20, 24, 30];
        let tagStyle = this.setFontSizes(set1);

        const {tagCloudDetail} = this.props;
        if(_.isEmpty(tagCloudDetail) == false && tagCloudDetail.length > 0){
            let grt18 = tagCloudDetail.filter(tag => tag.tagCount >= 18);
            let grt12 = tagCloudDetail.filter(tag => tag.tagCount >= 12);
            if(tagCloudDetail.length >= 25){
                if(grt18.length > 30 || grt12.length > 20){
                    tagStyle = this.setFontSizes(set3);
                }else if(grt18.length > 20 || grt12.length > 10){
                    tagStyle = this.setFontSizes(set2);
                }else if(grt18.length > 10 || grt12.length > 5){
                    tagStyle = this.setFontSizes(set1);
                }else if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set1);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }else if(tagCloudDetail.length >= 15){
                if(grt18.length > 10){
                    tagStyle = this.setFontSizes(set3);
                }else if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set2);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }else{
                if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set2);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }
        }


        if(this.props.platform == 'mobile') {
            //tagStyle = this.setFontSizes([12, 15, 22, 28, 36]);
            tagStyle = this.setFontSizes([13, 18, 23, 28, 33]);

            this.setState({
                tagPadding: 6
            });
        }

        this.setState({
            tagStyle: tagStyle
        });
    }

    /**
     * Just for testing the click even. This will be use for project link
     */

    clickMe = (tagId, tagName) => {
        if(this.props.platform == 'mobile') {
            window.postMessage(tagId, "*");
        } else {
            this.props.onClick(tagId, tagName);
        }
    };

    /**
     * rendomly return rotate text value either 90 or 0 only.
     */
    rotateAngle(max){
        let mx = max.tagCount;
        let randomValue =  Math.floor(Math.random() * Math.floor(mx));
        if(randomValue < (mx-randomValue)){
            return 0;
        }else{
            return 90;
        }

        /*if(max.length <= 7){
            return 90;
        } else {
            return 0;
        }*/
    }

    /**
     * Set font size of cloud tag
     * @param sizes
     * @returns {{style1: {fontSize: *, cursor: string}, style2: {fontSize: *, cursor: string}, style3: {fontSize: *, cursor: string}, style4: {fontSize: *, cursor: string}, style5: {fontSize: *, cursor: string}}}
     */
    setFontSizes(sizes) {
        return {
            style1: {
                fontSize: sizes[0],
                cursor: 'pointer',
                color: '#0070af',
                lineHeight:sizes[0]+'px'
            },
            style2: {
                fontSize: sizes[1],
                cursor: 'pointer',
                color: '#ff7428',
                lineHeight:sizes[1]+'px'
            },
            style3: {
                fontSize: sizes[2],
                cursor: 'pointer',
                color: '#41813a',
                lineHeight:sizes[2]+'px'
            },
            style4: {
                fontSize: sizes[3],
                cursor: 'pointer',
                color: '#ad00b4',
                lineHeight:sizes[3]+'px'
            },
            style5: {
                fontSize: sizes[4],
                cursor: 'pointer',
                color: '#b579bb',
                lineHeight:sizes[4]+'px'
            }
        };
    }

    componentDidMount(){
        //this.addMasonry()
    }

    MasonryChild(tagCloudDetail){
        return (
            tagCloudDetail.length  > 0 && tagCloudDetail.map(tag=>{
                if(tag.tagCount>0 && tag.tagCount<=4){
                    return <div key={tag.tagId} style={this.state.tagStyle.style1} className="item" onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                }else if(tag.tagCount>4 && tag.tagCount<=8){
                    return <div key={tag.tagId} style={this.state.tagStyle.style2} className="item vm" onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)} ><span>{tag.tagName}</span></div>
                }else if(tag.tagCount>8 && tag.tagCount<=12){
                    return <div key={tag.tagId} style={this.state.tagStyle.style3} className="item vm" onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}><span>{tag.tagName}</span></div>
                }else if(tag.tagCount>12 && tag.tagCount<=18){
                    return <div key={tag.tagId} style={this.state.tagStyle.style4} className="item" onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                }else if(tag.tagCount>18){
                    return <div key={tag.tagId} style={this.state.tagStyle.style5} className="item" onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                }
            })
        )
    }

    addMasonry = () => {
        $( function() {
            jQuery('#tags-area .item').each(function(){
                var elem = jQuery(this);
                if(elem.hasClass('vm')){
                    let h = elem.height();
                    let w = elem.width();
                    elem.attr('data-height',h+'px');
                    elem.attr('data-width',w+'px');
                    elem.height(elem.data('width'));
                    elem.width(elem.data('height'));
                    elem.find('span').css('position','relative');
                } else {
                    //elem.css({'height': elem.height(), 'width': elem.width()});
                }
            })
            jQuery('#tags-area').masonry({
                itemSelector: '.item',
            })
        });
    }


    /**
     * Render the component
     * @returns {*}
     */
    render() {
        const tagCloudDetail = (this.props.tagCloudDetail)?this.props.tagCloudDetail:[];
        return (
            <div>
                <div className='app-outer'>
                    <div className='app-inner' style={{background: 'white'}}>
                        <div id="tags-area" className="tags-area">
                            <WordCloud
                                data={skillsToDraw}
                                width={300}
                                height={450}
                                fontSizeMapper={fontSizeMapper}
                                rotate={rotate}
                                onWordClick={onWordClick}
                                font={'impact'}
                                random = {(d) =>  0.5 }
                                padding={'4'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, {updateTagId, projectListingGrid})(WordCloudMasonry);



// WEBPACK FOOTER //
// ./components/Common/WordCloudMasonry.js